export function getDistanceInKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) *
        Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d;
}

// Function to get lat/lng from an address
export async function getLatLng(address) {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status === "OK" && results[0]) {
                resolve(results[0].geometry.location);
            } else {
                reject(`Geocode failed for ${address}: ${status}`);
            }
        });
    });
}

export function calculateRouteOverlap(driverRoute, passengerRoute) {
    let overlapCount = 0;
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const threshold = user?.config?.OverlapThreshold || 8000;

    passengerRoute.forEach(passengerPoint => {
        driverRoute.forEach(driverPoint => {
            const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
                new window.google.maps.LatLng(passengerPoint.lat, passengerPoint.lng),
                new window.google.maps.LatLng(driverPoint.lat, driverPoint.lng)
            );

            if (distance < threshold) {
                overlapCount++;
            }
        });
    });

    const overlapPercentage = (overlapCount / passengerRoute.length) * 100;
    return overlapPercentage;
}

export async function canDriverReachPassenger(driver, passenger) {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    return new Promise((resolve, reject) => {
        const service = new window.google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
            {
                origins: [new window.google.maps.LatLng(driver.lat, driver.lng)],
                destinations: [new window.google.maps.LatLng(passenger.lat, passenger.lng)],
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
                if (status === "OK") {
                    const seconds = response?.rows?.[0]?.elements?.[0]?.duration?.value;
                    const maxMinutes = Number(user?.DriverReachPassengerInMinut) || 120;
                    resolve(Number.isFinite(seconds) && seconds / 60 <= maxMinutes);
                } else {
                    console.error("Distance Matrix API failed:", status);
                    resolve(false);
                }
            }
        );
    });
}

export async function getDriverRoute(driver) {
    return new Promise((resolve, reject) => {
        if (!driver.lat || !driver.lng || !driver.endLat || !driver.endLng) {
            console.warn("Invalid driver data", driver);
            resolve([]);
            return;
        }

        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: new window.google.maps.LatLng(driver.lat, driver.lng),
                destination: new window.google.maps.LatLng(driver.endLat, driver.endLng),
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === "OK") {
                    const routePath = result.routes[0].overview_path.map(point => ({
                        lat: point.lat(),
                        lng: point.lng(),
                    }));
                    resolve(routePath);
                } else {
                    console.error("Failed to get driver route:", status);
                    resolve([]);
                }
            }
        );
    });
}

export async function getPassengerRoute(passenger) {
    return new Promise((resolve, reject) => {
        if (!passenger.lat || !passenger.lng || !passenger.endLat || !passenger.endLng) {
            console.warn("Invalid passenger data", passenger);
            resolve([]);
            return;
        }

        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: new window.google.maps.LatLng(passenger.lat, passenger.lng),
                destination: new window.google.maps.LatLng(passenger.endLat, passenger.endLng),
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === "OK") {
                    const routePath = result.routes[0].overview_path.map(point => ({
                        lat: point.lat(),
                        lng: point.lng(),
                    }));
                    resolve(routePath);
                } else {
                    console.error("Failed to get passenger route:", status);
                    resolve([]);
                }
            }
        );
    });
}

export function checkUserOnRoute(user, selectedRoute) {
    if (!selectedRoute) return false;

    const threshold = user.checkUserOnRouteThreshold || 500; // Distance threshold in meters
    return selectedRoute.overview_path.some(routePoint => {
        const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
            new window.google.maps.LatLng(user.lat, user.lng),
            new window.google.maps.LatLng(routePoint.lat(), routePoint.lng())
        );
        return distance < threshold;
    });
}
